import { render, staticRenderFns } from "./slash_commands_menu.vue?vue&type=template&id=618f4dce"
import script from "./slash_commands_menu.vue?vue&type=script&lang=js"
export * from "./slash_commands_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports